// eslint-disable-next-line import/prefer-default-export
export const setRegion = value => dispatch => {
  dispatch({
    type: "SET_REGION",
    payload: value
  });
};
